import { Right } from './Right';
import { Left } from './Left';

export const CreateForm = [Left, Right];
